import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';

@Injectable({
  providedIn: 'root'
})
export class UpdatePosUserValuesService {

  constructor(private httpClient: HttpClient, private httpHeaderService: HttpHeadersService) { }
    public updatePOSUserValues(postData: any): Observable<any> {
      const headers=this.httpHeaderService.bearerHttpAuthorizationHeader();
      return this.httpClient.post(environment.servicePath + '/lfuser/update_posuser_values',postData, {headers});
    }
}
